import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient instance that can be safely imported anywhere.
 * This allows both React components (via QueryClientProvider) and
 * non-React code (like clientLoaders) to access the same query cache.
 */
let queryClient: QueryClient | null = null;

export const getQueryClient = (): QueryClient => {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // Prevent refetching on window focus for better UX
          refetchOnWindowFocus: false,
          // Cache data for 5 minutes before considering it stale
          staleTime: 5 * 60 * 1000,
          // Remove unused cache entries after 10 minutes
          cacheTime: 10 * 60 * 1000,
        },
      },
    });
  }
  return queryClient;
};
